import styled from 'styled-components/macro';
import { hideVisually } from 'polished';

import CompareListItem from 'components/Header/EntityCompareHeader/CompareList/CompareListItem/CompareListItem';

export const SearchLabel = styled('label')`
  ${hideVisually};
`;

export const SearchInput = styled('input')<any>`
  width: 100%;
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
  border: 0;
  background: none;
  padding: 0;
  margin: 0;
  color: white;
  outline: none;
  text-overflow: ellipsis;

  &::placeholder {
    color: rgba(255, 255, 255, 0.75);
  }

  ::-ms-clear {
    display: none;
  }
`;

export const Wrapper = styled('div')`
  flex-grow: 1;
  position: relative;
`;

export const CloseButton = styled('button')<any>`
  color: white;
  padding: 0;
  margin-left: ${({ theme }) => theme.spacing.small};
  opacity: 0.75;
  flex-shrink: 0;

  svg {
    display: block;
  }

  &:hover {
    opacity: 1;
  }
`;

export const StyledCompareListItem = styled(CompareListItem)<any>`
  margin-top: 0.5em;

  @media screen and (min-width: 30em) {
    margin-top: 1em;
  }
`;
